.root {
  display: flex;
  flex-direction: column;
}

.formLabel {
  margin: 16px;
  margin-bottom: 8px;
}

.sliderPadding {
  padding-left: 16px;
  padding-right: 16px;
}

.helpText {
  margin-bottom: 32px;
}

.optionGridFlex {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

.optionActions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.optionTextField {
  flex: 1;
}

.createButton {
  margin: 16px;
}

.group {
  display: flex;
  flex-direction: column;
  margin-block: var(--tuna-spacing-2);
}

.groupFields {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--tuna-spacing-2);
}

/* An option row in a grouped poll, with its Group select at the end. */
.groupedOption {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-2);
}

.groupedOption > :first-child {
  flex: 1 1 0;
  min-width: 0;
}

/*
 * The group selects size to their content (the widest option) instead of filling the row. Scoped under the row so it
 * outranks the ui-lib Select wrapper's `flex: 1 1 auto` whatever order the stylesheets load in.
 */
.groupedOption .compactSelect,
.groupFields .compactSelect {
  flex: 0 0 auto;
  width: auto;
}

.groupedOption .compactSelect select,
.groupFields .compactSelect select {
  width: auto;
}
